import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TenantService } from '../services/tenant.service';

/**
 * Runs only on native (Android/iOS) builds.
 * On web the guard passes straight through — the existing /:marketId routing still works.
 * On native, redirects to /onboarding when no tenant config has been saved yet.
 */
export const tenantGuard = async (): Promise<boolean | import('@angular/router').UrlTree> => {
  if (!Capacitor.isNativePlatform()) return true;

  const tenant = inject(TenantService);
  const router = inject(Router);

  const cfg = await tenant.loadSavedConfig();
  if (!cfg) {
    return router.parseUrl('/onboarding');
  }
  return true;
};
